// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WIul","type":"styles_type__2Og0W","choices":"styles_choices__3WB4M"};